import api from './api';
import { Step, CreateStepInput } from '../types/workshop.types';

export const stepService = {
  async getSteps(workshopId: string): Promise<Step[]> {
    const response = await api.get(`/workshops/${workshopId}/steps`);
    return response.data;
  },

  async createStep(workshopId: string, data: CreateStepInput): Promise<Step> {
    const response = await api.post(`/workshops/${workshopId}/steps`, data);
    return response.data;
  },

  async updateStep(stepId: string, data: Partial<Step>): Promise<Step> {
    const response = await api.patch(`/steps/${stepId}`, data);
    return response.data;
  },

  async deleteStep(stepId: string): Promise<void> {
    await api.delete(`/steps/${stepId}`);
  },

  async reorderSteps(workshopId: string, steps: { id: string; orderIndex: number }[]): Promise<void> {
    await api.put(`/workshops/${workshopId}/steps/reorder`, { steps });
  },
};
